import { Button, Checkbox, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function ContactTenant({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Contact tenant about past due rent" />
          </Col>
          <Col span={24}>
            <p className="red-info-heading">
              If the tenant owes less than $200 do not issue a notice unless you
              verify with property owner or broker first that it should be sent.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">
              Send this msg to the tenant by email/sms in appfolio
            </h3>
          </Col>
          <Col span={24}>
            <p>
              We have issued a notice to you for your past due balance. There is
              still time to get a payment in. Please do so asap. At this point
              you will not be able to pay online but you can mail in a money
              order to PO Box 1451 Bethany OK 73008 or you can drop off a money
              order in our mail slot at 1800 Canyon Park Circle Suite 202
              Edmond, OK 73013. We are not able to accept cash payments. If you
              are not able to pay your rent and do not want an eviction on your
              record you can take advantage of our "Cash For Keys program" where
              we could give you $200 for vacating the property and turning in
              your keys within the next 2 days.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">
              Send this msg to the owner by email in appfolio-{" "}
              <strong className="red-info-heading">
                put the property address in the subject line
              </strong>
            </h3>
          </Col>
          <Col span={24}>
            <p>
              We have just issued a Pay/Quit notice to your tenant at the
              property above they will have 5 days to pay the past due balance.
              If they do not pay by the deadline we will begin the process to
              file for eviction. This process can take several weeks to
              complete. We file for court hearings twice a month. We will notify
              you once we have a hearing date set. If the tenant brings in a
              payment of at least 75% of the amount due we will accept it.
            </p>
          </Col>
          <Col span={24}>
            <p>Generate pay quit notice</p>
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="gotoLink" valuePropName="checked">
              <Checkbox>
                go to -{" "}
                <span className="onclick-text">
                  https://integrityoklahoma.appfolio.com/letter_writing/tenant_letters/3/filter
                </span>
              </Checkbox>
            </Form.Item>
            <Form.Item label="2" name="printCopyMail" valuePropName="checked">
              <Checkbox>print one copy to mail</Checkbox>
            </Form.Item>
            <Form.Item
              label="3"
              name="printOneEnvelope"
              valuePropName="checked"
            >
              <Checkbox>print one envelope</Checkbox>
            </Form.Item>
            <Form.Item
              label="4"
              name="emailSignedToBroker"
              valuePropName="checked"
            >
              <Checkbox>
                email signed copy to broker (Teresa) of letter for posting
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="5"
              name="putLetterInEnvelope"
              valuePropName="checked"
            >
              <Checkbox>
                put letter in envelope, put certified mail slip and put stamp on
                letter
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="6"
              name="noticeOnFrontDesk"
              valuePropName="checked"
            >
              <Checkbox>put notice on front desk for mailing</Checkbox>
            </Form.Item>
            <Form.Item
              label="7"
              name="fillOutGreenFormBeforeMai;"
              valuePropName="checked"
            >
              <Checkbox>
                make sure and fill out green form before mailing.
              </Checkbox>
            </Form.Item>
            <Form.Item label="8" name="noticeMailed" valuePropName="checked">
              <Checkbox>
                NOTICES MUST BE MAILED WITHIN 24 HOURS OF PRINTING
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ContactTenant;
